import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function AgilityLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="AgilityLogo">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4189 16.7075H4.61882L9.74436 6.27316L14.8699 16.7075L16.3649 19.8163H19.4514L9.7441 0.0556641L0.0371094 19.8163H12.6102L11.4189 16.7075Z"
        fill="#FFCB28"
      />
    </LogoSkeleton>
  )
}
